import { render, staticRenderFns } from "./SponsorJobOffersList.vue?vue&type=template&id=1efb2a26&"
import script from "./SponsorJobOffersList.vue?vue&type=script&lang=js&"
export * from "./SponsorJobOffersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports